export default {
  'imm5562.steps.sectionA': '主申请人（您自己）',
  'imm5562.steps.sectionB': '您的配偶或同居伴侣',
  'imm5562.steps.sectionC': '您18岁或以上的受抚养子女',

  'imm5562.title.principalApplicant': 'A部分：主申请人（您自己）',
  'imm5562.description.principalApplicant':
    '列出您在过去10年中（或如果您未满18岁，则自18岁生日以来）在原籍国或居住国以外的所有旅行。包括所有旅行：旅游、商务、培训等。如果您在此期间未出国旅行，请勾选“未旅行”。',

  'imm5562.title.partnerApplicant': 'B部分：您的配偶或同居伴侣',
  'imm5562.description.partnerApplicant':
    '列出您的配偶或同居伴侣在过去10年中（或如果他们未满18岁，则自18岁生日以来）在原籍国或居住国以外的所有旅行。包括所有旅行：旅游、商务、培训等。如果他们在此期间未出国旅行，请勾选“未旅行”。',

  'imm5562.title.dependantApplicant': 'C部分：您18岁或以上的受抚养子女',
  'imm5562.description.dependantApplicant':
    '列出您18岁或以上的受抚养子女在过去10年中（或如果他们未满18岁，则自18岁生日以来）在原籍国或居住国以外的所有旅行。包括所有旅行：旅游、商务、培训等。如果他们在此期间未出国旅行，请勾选“未旅行”。',

  'imm5562.title.formList.trips': '旅行 #',

  'imm5562.fields.haveNotTravelled': '未旅行',
  'imm5562.fields.fullName': '全名',
  'imm5562.fields.from': '从（YYYY/MM）',
  'imm5562.fields.to': '到（YYYY/MM）',
  'imm5562.fields.destination': '目的地（城市，国家）',
  'imm5562.fields.length': '时长（例如：6天）',
  'imm5562.fields.purposeOfTravel': '旅行目的（例如：商务）',
};
